module.exports = __webpack_public_path__ + "static/media/gmail-24x24.542092fc.png";